
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/materiali",
      function () {
        return require("private-next-pages/materiali/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/materiali"])
      });
    }
  